import {Options} from '@fl/cmsch-fe-library';

import {t} from 'app/translations';

/**
 * Creates the localized calf-sex options used by comprehensive animal-browser filters.
 *
 * @returns The select options for male and female calves.
 */
export const getCalfSexOptions = (): Options<string> => [
    {
        value: 'MALE',
        label: t('animalBrowser')('maleCalf'),
    },
    {
        value: 'FEMALE',
        label: t('animalBrowser')('femaleCalf'),
    },
];
